import React from 'react';
import styles from '../css/comuns/ServicosEssenciaisInternet.module.css';
import { config } from '../../data';

const ServicosEssenciaisInternet = () => {
    const items = config.content.servicosEssenciaisInternet;
    const images = config.images.servicosEssenciaisInternet;

    return (
        <div className={styles['container16']}>
            <div className={styles['container']}>
                <div className={styles['row']}>
                    {items.map((item, index) => (
                        <div className={styles['col']} key={index}>
                            <div className={styles['item16']}>
                                <img src={images[item.imgKey]} alt={item.alt} className={styles['img-fluid']} />
                                <h3>{item.titulo}</h3>
                                <p>{item.descricao}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServicosEssenciaisInternet;